import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.0",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#e20031",
      d: "M322 357c-35 10-69 16-102 19l122 121 43-161c-19 7-40 15-63 21m108-201c-44 29-99 54-149 68-70 20-140 27-194 17L4 159 462 36z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#003d8f",
      d: "m7 191-2-7 50 49q-40.5-15-48-42m490 52c-34 42-90 73-180 99-91 26-183 25-233-2-17-10-28-22-32-37l-27-65 3 2c54 30 155 30 257 0 82-23 168-71 212-117zM342 52 22 137C55 90 132 44 222 18c25-7 81-16 120-15z"
    }, null, -1)
  ]))]))
}
export default { render: render }